import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "ImportUpload";
var classes = {
    elementSummary: "".concat(PREFIX, "-elementSummary"),
    contentSection: "".concat(PREFIX, "-contentSection")
};
var StyledImportUpload = styled(Box)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[theme.breakpoints.down("md")] = {
            justifyContent: "center"
        },
        _b[theme.breakpoints.down("sm")] = {
            padding: theme.spacing(2),
            width: "70vw"
        },
        _b);
});

export { classes, StyledImportUpload as default };
//# sourceMappingURL=index.styled.js.map
